import { Address } from "./address.model"
import { Link } from "./link.model"

export const Salutation =  {
	MR: "Herr",
	MS: "Frau",
	COMPANY: "Firma",
}

export class Customer {
	uuid: string
	firstname: string
	lastname: string
	formalName: string
	informalNname: string
	email: string
	phoneNumber: string
	companyName: string
	postalCode: string
	city: string
	street: string
	houseNumber: string
	salutation: string
	defaultShippingAddress: Address
	defaultBillingAddress: Address
	addresses: Address[]
	archived: boolean
	_links: {
		self: Link
		relocation: Link
	}
}



// WEBPACK FOOTER //
// ./src/app/models/customer.model.ts